import { ApolloQueryResult } from '@apollo/client';

import {
  StoreZekiMessage,
  ZApiIntegrationType,
  EvolutionApiIntegrationType,
} from 'src/graphql/generated';

import { ConfigZapiModal } from './config-zApi-modal';
import { ConfigEvolutionApiModal } from './config-evolution-api-modal';

type Props = {
  open: boolean;
  onClose: () => void;
  zekiMessageType?: StoreZekiMessage | null;
  currentDataZapi?: Pick<ZApiIntegrationType, 'zApiId' | 'zApiToken' | 'token'> | null;
  currentDataEvolution?: Pick<
    EvolutionApiIntegrationType,
    'apiKey' | 'instance' | 'connected' | 'phoneNumber'
  > | null;
  refetch: () => Promise<ApolloQueryResult<any>>;
};

export function ConfigZekiMessageModal({
  open,
  onClose,
  zekiMessageType,
  currentDataZapi,
  currentDataEvolution,
  refetch,
}: Props) {
  if (zekiMessageType === StoreZekiMessage.Zapi) {
    return (
      <ConfigZapiModal
        open={open}
        onClose={onClose}
        currentData={currentDataZapi as any}
        title="Integração ZekiMessage"
        refetch={refetch}
      />
    );
  }

  return (
    <ConfigEvolutionApiModal
      open={open}
      onClose={onClose}
      currentData={currentDataEvolution as any}
      disableForm={Boolean(currentDataEvolution)}
      title="Integração ZekiMessage"
      refetch={refetch}
    />
  );
}
